export default "__VITE_ASSET__C$fura$d__"